import { Pipe, PipeTransform } from '@angular/core';
import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { MailingChannelEnum } from '@zaoblako/shared/modules/notification/enums/mailing.channel.enum';
import { MailingChannelEnumI18n } from '@zaoblako/shared/modules/notification/i18n/mailing.channel.enum.i18n';

@Pipe({
  standalone: true,
  name: 'mailingChannelName'
})
export class MailingChannelNamePipe implements PipeTransform {
  public transform(chanel: MailingChannelEnum): string {
    return MailingChannelEnumI18n[I18nLocalesEnum.RU_RU][chanel] || '';
  }
}
